"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = NavLogo;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _logo = _interopRequireDefault(require("../logos/logo"));
var _utils = require("../../utils/utils");
// Packages

// Components

// Utils

// Styles
const {
  below
} = (0, _utils.getMediaQueries)();
const LogoWrapper = _styledComponents.default.div.withConfig({
  displayName: "logo__LogoWrapper",
  componentId: "sc-i57jm4-0"
})(["display:flex;align-items:center;.headshot{border-radius:50%;flex-shrink:0;width:48px;height:48px;", "}&.logo-headshot{svg{width:34px;height:40px;", "}}&.fullABMGLogo{height:45px;margin-right:40px;transition:0.3s ease-in-out;", ";", ";svg{width:auto;max-height:100%;max-width:100%;}}height:64px;margin-right:40px;transition:0.3s ease-in-out;", ";"], below.tablet`
    width:40px;
    height:40px;
    `, below.tablet`
    width:29px;
    height:34px;
    `, below.tablet`
      height:35px;
      margin-right: 0;
    `, below.mobile`
      height:25px;
    `, below.tablet`
    max-height:40px;
    margin-right: 0;
  `);

// Main Component
function NavLogo({
  logo,
  className
}) {
  return /*#__PURE__*/_react.default.createElement(LogoWrapper, {
    className: className || "fullABMGLogo"
  }, logo || /*#__PURE__*/_react.default.createElement(_logo.default, null));
}

// Prop Types
NavLogo.propTypes = {
  /** className for the component */
  className: _propTypes.default.string,
  /**
   * Logo component can be used or default logo will be used
   */
  logo: _propTypes.default.element
};
NavLogo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NavLogo",
  "props": {
    "className": {
      "description": "className for the component",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "logo": {
      "description": "Logo component can be used or default logo will be used",
      "type": {
        "name": "element"
      },
      "required": false
    }
  }
};